export const GROK_IMAGINE_ENDPOINTS = Object.freeze({
  textToImage: 'xai/grok-imagine-image/v2.0/text-to-image',
  edit: 'xai/grok-imagine-image/v2.0/edit',
});

export const SEEDREAM_4_5_ENDPOINTS = Object.freeze({
  textToImage: 'fal-ai/bytedance/seedream/v4.5/text-to-image',
  edit: 'fal-ai/bytedance/seedream/v4.5/edit',
});

export const SEEDREAM_5_PRO_ENDPOINTS = Object.freeze({
  textToImage: 'bytedance/seedream/v5/pro/text-to-image',
  edit: 'bytedance/seedream/v5/pro/edit',
});

export const NANO_BANANA_2_ENDPOINTS = Object.freeze({
  textToImage: 'fal-ai/nano-banana-pro',
  edit: 'fal-ai/nano-banana-pro/edit',
});

export const KLING_O1_IMAGE_ENDPOINTS = Object.freeze({
  generate: 'fal-ai/kling-image/o1',
});

export const LTX_ENDPOINTS = Object.freeze({
  textToVideo: 'lightricks/ltx-2.5/text-to-video/pro',
  imageToVideo: 'lightricks/ltx-2.5/image-to-video/pro',
  // Pinned to 2.3 deliberately: LTX 2.5 publishes no extend endpoint
  // (`lightricks/ltx-2.5/extend-video` probes 404, 2.3's probes 200). One path
  // on an older endpoint, not a dual path. Removal condition: a 2.5 extend
  // endpoint appears, or timeline extend moves models.
  extendVideo: 'fal-ai/ltx-2.3/extend-video',
});

export const KLING_O1_EDIT_ENDPOINTS = Object.freeze({
  videoToVideo: 'fal-ai/kling-video/o3/standard/video-to-video/edit',
});

export const MINIMAX_H3_MAX_SPECIAL_ENDPOINTS = Object.freeze({
  relight: 'minimax/h3-max/relight',
  threeDToVideo: 'minimax/h3-max/3d-to-video',
  recast: 'minimax/h3-max/recast',
});

export const GEMINI_OMNI_FLASH_ENDPOINTS = Object.freeze({
  textToVideo: 'google/gemini-omni-flash/v1.1/text-to-video',
  imageToVideo: 'google/gemini-omni-flash/v1.1/image-to-video',
  referenceToVideo: 'google/gemini-omni-flash/v1.1/reference-to-video',
  edit: 'google/gemini-omni-flash/v1.1/edit',
});

export const MINIMAX_MUSIC_ENDPOINTS = Object.freeze({
  textToAudio: 'minimax/music-3',
});

export const TRIPO_3D_ENDPOINTS = Object.freeze({
  imageToThreeD: 'tripo3d/tripo/v2.5/image-to-3d',
});

export const RODIN_ENDPOINTS = Object.freeze({
  imageToThreeD: 'fal-ai/hyper3d/rodin/v2',
});

export const MESHY_ENDPOINTS = Object.freeze({
  textToThreeD: 'meshy/v7/text-to-3d',
  imageToThreeD: 'meshy/v7/image-to-3d',
  multiImageToThreeD: 'meshy/v7/multi-image-to-3d',
});

export const AUDIO_ISOLATION_ENDPOINTS = Object.freeze({
  audioToAudio: 'fal-ai/elevenlabs/audio-isolation',
});

export const AUDIO_STEM_SEPARATION_ENDPOINTS = Object.freeze({
  audioToAudio: 'fal-ai/demucs',
});

export const AUDIO_SECTION_ENDPOINTS = Object.freeze({
  outpaint: 'fal-ai/stable-audio-3/medium/audio-outpainting',
});

export const AUDIO_RESTYLE_ENDPOINTS = Object.freeze({
  audioToAudio: 'fal-ai/stable-audio-25/audio-to-audio',
});
